import { HttpClient } from '../../httpClient'
import { OpalApi } from '../../schema'

type AddToBoard =
  | OpalApi<'MomentsAddToBoardsBFFV1', 200>
  | OpalApi<'MomentsAddToBoardsBFFV1', 202>

export const createMomentsToBoardsRequest: AddToBoard = async (args = {}) => {
  const url = new URL(
    '/asgard-bff/moments/add_to_boards/',
    window.location.origin
  )

  return HttpClient()
    .post(url.toString(), args.requestBody)
    .then((res) => {
      if (res.status === 202) return
      return res.data
    })
}
